(function ($)
{    
    const KEY_RECAPTCHA_TOKEN = "g-recaptcha-response";

    $.widget("ui.ContactForm",
        {
            _vars:
            {
                recaptchaHolderId: undefined
            },
            options:
            {
                FormTarget: '/Core/ContactForm/',
                UseRecaptcha: false,
                RecaptchaSubType: null,
                RecaptchaSiteKey: null,
                RecaptchaErrorV2HtmlId: null,
                RecaptchaElementV2HtmlId: null,
                RecaptchaInputV3HtmlId: null
            },

            _destroy: function ()
            {
                return undefined;
            },

            _init: function ()
            {
                return undefined;
            },

            _create: function ()
            {
                let self = this;
                let jElement = $(self.element);

                if (jElement.find('form').length !== 1)
                {
                    return;
                }
                self._AjaxRequestObject = null;

                let jForm = jElement.find('form');
                jForm.vpformchecker({
                    useButtons: false,
                    requiredMarkerText: "(required)"
                });

                // 3) ADD YOUR OWN VERIFICATION FUNCTIONS AND PROCESSING FUNCTIONs

                function extraCheckingFunc()
                {
                    let success = true;
                    let jTextArea = jForm.find('textarea[name="ContactMessage"]');
                    let htmlTagsRegex = new RegExp(/<("[^"]*"|'[^']*'|[^'">])*>/);
                    let hasHtmlTags = htmlTagsRegex.test(jTextArea.val());
                    if (hasHtmlTags)
                    {
                        success = false;
                        jForm.vpformchecker("applyWarningFieldStyling", jTextArea);
                        alert('Text area does not allow html tags.');
                    }

                    if (self.options.UseRecaptcha && self.options.RecaptchaSubType === "V2Checkbox")
                    {
                        let response = grecaptcha.getResponse();
                        if (response)
                        {
                            $(`#${self.options.RecaptchaErrorV2HtmlId}`).html('');
                        }
                        else
                        {
                            $(`#${self.options.RecaptchaErrorV2HtmlId}`).html('Please check the reCAPTCHA.');
                            success = false;
                        }
                    }

                    return success;
                };

                jForm.vpformchecker('addOtherFunction', extraCheckingFunc);


                function waitForGrecaptcha()
                {
                    if (typeof grecaptcha !== "undefined")
                    {
                        if (self.options.RecaptchaSubType === "V2Checkbox")
                        {
                            grecaptcha.ready(function ()
                            {
                                grecaptcha.render(self.options.RecaptchaElementV2HtmlId, {'sitekey': self.options.RecaptchaSiteKey});
                            });
                        }
                        else if (self.options.RecaptchaSubType === "V2Invisible")
                        {
                            grecaptcha.ready(function ()
                            {
                                self._vars.recaptchaHolderId = grecaptcha.render(
                                    self.options.RecaptchaElementV2HtmlId,
                                    {
                                        'sitekey': self.options.RecaptchaSiteKey,
                                        'size': "invisible",
                                        'badge': "inline",
                                        'callback': function (token)
                                        {
                                            $(self.element).find(`#${self.options.RecaptchaInputV3HtmlId}`).val(token);
                                            self._completeSubmit();
                                        }
                                    });
                            });
                        }
                    }
                    else
                    {
                        setTimeout(waitForGrecaptcha, 250);
                    }
                }

                if (self.options.UseRecaptcha)
                {
                    waitForGrecaptcha();
                }

                jForm.find('input[name=ContactName]').focus();

                jElement.off('click', '.send_button').on('click', '.send_button',
                    function (aEvent)
                    {
                        aEvent.preventDefault();
                        self.Submit();
                        return false;
                    });

                jElement.off('click', '.cancel_button').on('click', '.cancel_button', function (aEvent)
                {
                    aEvent.preventDefault();
                    self.Cancel();
                    return false;
                });
            },

            _completeSubmit: function ()
            {
                let self = this;
                let jElement = $(self.element);

                self._htmlEncodeInput(jElement.find('#ContactName'));
                self._htmlEncodeInput(jElement.find('#ContactEmail'));
                self._htmlEncodeInput(jElement.find('#ContactPhone'));
                self._htmlEncodeInput(jElement.find('#ContactSubject'));
                self._htmlEncodeInput(jElement.find('#ContactMessage'));

                let data = jElement.find('form').serializeArray();                
                let token = $(self.element).find(`#${self.options.RecaptchaInputV3HtmlId}`).val();
                if (token !== undefined)
                {
                    data[KEY_RECAPTCHA_TOKEN] = token;
                }

                self._AjaxRequestObject = $.ajax(
                    jElement.find('form').attr('action'),
                    {
                        data: data,
                        success: function (aData)
                        {
                            jElement.replaceWith(aData);
                        },
                        error: function ()
                        {
                            jElement.replaceWith('An error occurred sending the e-mail.');
                        },
                        complete: function ()
                        {
                            self._AjaxRequestObject = null;
                        },
                        type: 'POST'
                    }
                );
            },

            Submit: function ()
            {
                let self = this;
                let jElement = $(self.element);
                let jForm = jElement.find('form');

                if (self._AjaxRequestObject !== null)
                {
                    return;
                }

                let success = jForm.vpformchecker('checkForm');
                if (success)
                {
                    if (!self.options.UseRecaptcha)
                    {
                        self._completeSubmit();
                    }
                    else if (self.options.RecaptchaSubType === 'V3Score')
                    {
                        grecaptcha.ready(function ()
                        {
                            grecaptcha
                                .execute(self.options.RecaptchaSiteKey, {action: 'submit'})
                                .then(function (token)
                                {
                                    $(self.element).find(`#${self.options.RecaptchaInputV3HtmlId}`).val(token);
                                    self._completeSubmit();
                                });
                        });
                    }
                    else if (self.options.RecaptchaSubType === 'V2Invisible')
                    {
                        grecaptcha.ready(() =>
                        {
                            grecaptcha.execute(self._vars.recaptchaHolderId);
                        });
                    }
                    else
                    {
                        self._completeSubmit();
                    }
                }
            },

            Cancel: function ()
            {
                if (this._AjaxRequestObject !== null)
                {
                    this._AjaxRequestObject.abort();
                    this._AjaxRequestObject = null;
                }

                FBAjaxDialog.FindAndClose();
            },

            Close: function ()
            {
                this.Cancel();
            },

            _htmlEncodeInput: function (aInputElement)
            {
                if (FBUtilities.IsParameterUndefinedOrEmpty(aInputElement))
                {
                    return;
                }

                aInputElement.val(FBCommon_1_2.htmlEncode(aInputElement.val()));
            }
        });
}(jQuery));
